import {IPagedResult} from '../common/PagedResult';
import {Paging} from '../common/Paging';
import {HSPOpportunitiesDetailModel} from './HSPOpportunitiesDetailModel';

export interface IOpportunitiesSearchPaged extends IPagedResult<HSPOpportunitiesDetailModel> {
  totalOpportunities?: number | undefined;
}

export class HSPOpportunitiesSearchPaged implements IHSPOpportunitiesSearchPaged {
  totalOpportunities?: number | undefined;
  paging?: Paging | undefined;
  result?: HSPOpportunitiesDetailModel[] | undefined;

  constructor(data?: IHSPOpportunitiesSearchPaged) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.totalOpportunities = Data["totalOpportunities"];
      this.paging = Data["paging"] ? Paging.fromJS(Data["paging"]) : <any>undefined;
      if (Array.isArray(Data["result"])) {
        this.result = [] as any;
        for (let item of Data["result"])
          this.result!.push(HSPOpportunitiesDetailModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): HSPOpportunitiesSearchPaged {
    data = typeof data === 'object' ? data : {};
    let result = new HSPOpportunitiesSearchPaged();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalOpportunities"] = this.totalOpportunities;
    data["paging"] = this.paging ? this.paging.toJSON() : <any>undefined;
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    return data;
  }
}

export interface IHSPOpportunitiesSearchPaged {
  totalOpportunities?: number | undefined;
  paging?: Paging | undefined;
  result?: HSPOpportunitiesDetailModel[] | undefined;
}